import { useEffect } from "react";
import { applyBranding } from "../lib/branding";

/**
 * Coloca a logo da empresa como favicon e o nome no título da aba
 * quando os dados de GET /companies/{code} chegam (ver useCompany).
 * Também guarda nome/logo/telefone em cache (lib/branding.js) para a próxima visita
 * e para o envio do pedido por WhatsApp (useSendToWhatsApp).
 *
 * @param {Object|null} company - CompanyResponseDTO ({ name, logoUrl, contactPhone, ... })
 */
export const useCompanyBranding = (company) => {
  const name = company?.name;
  const logoUrl = company?.logoUrl;
  const contactPhone = company?.contactPhone;

  useEffect(() => {
    if (!name && !logoUrl) return;
    applyBranding({ name, logoUrl, contactPhone }, { persist: true });
  }, [name, logoUrl, contactPhone]);
};
